/**
 * Тема интерфейса.
 *
 * По умолчанию — та, что в Telegram: приложение внутри мессенджера не может
 * быть светлым пятном в тёмном телефоне. Но выбор человека главнее: тёмная
 * тема в финансовом интерфейсе это не украшение, а условие читаемости в
 * темноте, и навязывать системную, когда человек выбрал другое, нельзя.
 */

import { getColorScheme, onThemeChange } from './telegram.ts';

export type Theme = 'dark' | 'light';

const STORAGE_KEY = '78.theme';

function saved(): Theme | null {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    return value === 'dark' || value === 'light' ? value : null;
  } catch {
    // приватный режим — просто идём за Telegram
    return null;
  }
}

export function currentTheme(): Theme {
  return saved() ?? getColorScheme();
}

function apply(theme: Theme): void {
  document.documentElement.dataset['theme'] = theme;
}

export function setTheme(theme: Theme): void {
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // не смогли запомнить — не повод не переключать
  }
  apply(theme);
}

/** Ставит тему на старте и следит за сменой в Telegram. */
export function initTheme(): void {
  apply(currentTheme());
  onThemeChange(() => {
    // Свой выбор важнее системного: раз человек переключил вручную, смена
    // темы в телефоне не должна его отменять.
    if (saved() === null) apply(getColorScheme());
  });
}
